import {EnvUtils} from "../utils/env-utils";

export abstract class ChatEngineConfig {
    public static readonly projectId = EnvUtils.readString('REACT_APP_CHAT_ENGINE_PROJECT_ID');
}
